import { render } from "./Webpages.vue?vue&type=template&id=f4bd1852"
import script from "./Webpages.vue?vue&type=script&lang=js"
export * from "./Webpages.vue?vue&type=script&lang=js"

import "./Webpages.vue?vue&type=style&index=0&id=f4bd1852&lang=css"
script.render = render

export default script